import createIcon from '../../createIcon';

/**
 * @component @name NotificationAdd
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOCAyMEgxMkMxMiAyMS4xIDExLjEgMjIgMTAgMjJDOC45IDIyIDggMjEuMSA4IDIwWk0xMiA5QzEyIDExLjYxIDEzLjY3IDEzLjgzIDE2IDE0LjY2VjE3SDE4VjE5SDJWMTdINFYxMEM0IDcuMjEgNS45MSA0Ljg2IDguNSA0LjJWMy41QzguNSAyLjY3IDkuMTcgMiAxMCAyQzEwLjgzIDIgMTEuNSAyLjY3IDExLjUgMy41VjQuMkMxMi4yMSA0LjM4IDEyLjg2IDQuNjkgMTMuNDUgNS4xQzEyLjU0IDYuMTQgMTIgNy41MSAxMiA5Wk0yMiA4SDE5VjVIMTdWOEgxNFYxMEgxN1YxM0gxOVYxMEgyMlY4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NotificationAdd = createIcon('NotificationAdd', [
  [
    'path',
    {
      d: 'M8 20H12C12 21.1 11.1 22 10 22C8.9 22 8 21.1 8 20ZM12 9C12 11.61 13.67 13.83 16 14.66V17H18V19H2V17H4V10C4 7.21 5.91 4.86 8.5 4.2V3.5C8.5 2.67 9.17 2 10 2C10.83 2 11.5 2.67 11.5 3.5V4.2C12.21 4.38 12.86 4.69 13.45 5.1C12.54 6.14 12 7.51 12 9ZM22 8H19V5H17V8H14V10H17V13H19V10H22V8Z',
      key: '1g291f',
    },
  ],
]);

export default NotificationAdd;
